export var PI = 'pi';
export var HUB = 'hub';
export var ZIP = 'zip';
export var BUSINESS_BOOKER = 'business-booker';
export var LEISURE_BRANDS = ['pi', 'pid', 'hub', 'zip'];